import Vue from "vue";
import VueRouter from "vue-router";

import { authorized, publicAccess } from '@/_router/modules/authorisation'

Vue.use(VueRouter);

const routes =  [
  // Home
  {
    path: "/",
    name: "Home",
    component: () => import('@/views/HomePage/Home'),
    beforeEnter: authorized
  },
  // Auth
  {
    path: "/welcome",
    name: "Auth",
    component: () => import('@/views/_Auth/Auth'),
    beforeEnter: publicAccess
  },
  // SET:404
  {
    path: "*",
    name: "404",
    component: () => import('@/views/PageError/NotFound'),
  },
];

const router = new VueRouter({
  mode: "history",
  routes
});
export default router;
